import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardHeader, CardText, TextField, DropDownMenu, MenuItem,
} from 'material-ui';
import { StyleSheet, css } from 'aphrodite';
import moment from 'moment';
import parseFormat from 'moment-parseformat';

import DateField from '../DateFieldComponent';

export default class DateCalculations extends React.Component {
  static propTypes = {
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
  }

  constructor(props) {
    super(props);

    this.state = {
      days: 180,
      sign: 'after',
      date: moment().format('MMMM Do YYYY'),
    };
  }

  changeDays = ({ target: { value } }) => {
    this.setState({ days: value });
  }

  changeSign = (event, index, value) => {
    this.setState({ sign: value });
  }

  changeDate = ({ target: { value } }) => {
    this.setState({ date: value });
  }


  render() {
    const { className } = this.props;
    const { days, sign, date } = this.state;

    const parsedDate = moment(date, parseFormat(date));
    let result;
    if (sign === 'after') {
      result = parsedDate.add(days, 'days');
    } else {
      result = parsedDate.subtract(days, 'days');
    }

    return (<Card className={className}>
      <CardHeader title='Date Calculations' />
      <CardText>
        <div className={css(styles.firstLine)}>
          <TextField
            type='number'
            id='days'
            className={css(styles.daysInput)} value={days} onChange={this.changeDays}
          />
          <span className={css(styles.daysSpan)}>days</span>
          <DropDownMenu value={sign} onChange={this.changeSign}>
            <MenuItem value='after' primaryText='after' />
            <MenuItem value='before' primaryText='before' />
          </DropDownMenu><br />
        </div>
        <DateField
          id='date'
          className={css(styles.dateInput)}
          value={date}
          onChange={this.changeDate}
        />
        <div className={css(styles.resultsDiv)}>
          is <span className={css(styles.resultsSpan)}>
            {result.format('MMMM Do YYYY')}
          </span>
        </div>
      </CardText>
    </Card>);
  }
}

const styles = StyleSheet.create({
  daysInput: {
    width: 50,
  },
  dateInput: {
    width: '100%',
  },
  firstLine: {
    display: 'flex',
    alignItems: 'baseline',
  },
  daysSpan: {
    paddingLeft: 24,
  },
  resultsSpan: {
    fontWeight: 'bold',
    fontSize: 20,
  },
  resultsDiv: {
    paddingTop: 15,
  },
});



// WEBPACK FOOTER //
// /src/components/Widgets/DateCalculations.js